import { FC } from 'react';
import { Helmet } from 'react-helmet';

import {
  SettingsCard,
  SettingsCardSkeleton,
} from '~/components/unified/SettingsCard';

import { MembershipList } from './MembershipList';
import { useUserMemberships } from './useUserMemberships';

export const UserTeamSettings: FC = () => {
  const { loading, memberships } = useUserMemberships();

  if (loading)
    return (
      <div className="space-y-8">
        <SettingsCardSkeleton className="h-96" />
      </div>
    );

  return (
    <>
      <Helmet>
        <title>Your teams</title>
      </Helmet>
      <SettingsCard>
        <SettingsCard.Header>
          <SettingsCard.Heading>Team memberships</SettingsCard.Heading>
        </SettingsCard.Header>
        <SettingsCard.Body>
          <MembershipList memberships={memberships} />
        </SettingsCard.Body>
      </SettingsCard>
    </>
  );
};
